import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminCheckSession } from "./adminApi";

export default function AdminRequireAuth({ children }) {
  const [checking, setChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function check() {
      try {
        const data = await adminCheckSession();
        if (mounted) {
          setIsAuthenticated(data?.authenticated === true);
        }
      } catch (_) {
        if (mounted) {
          setIsAuthenticated(false);
        }
      } finally {
        if (mounted) {
          setChecking(false);
        }
      }
    }

    check();

    return () => {
      mounted = false;
    };
  }, []);

  if (checking) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
